import
{
  Container,
  StyledSelect,
  StyledMenuItem,
  SelectIcon,
  StyledColorIcon,
  StyledAutoBox,
  StyledAutocomplete,
} from "./CustomSelect.styles";
import FieldError from "../FieldError/FieldError";
import Label from "../../Typography/Label/Label";
import { TextField } from "@mui/material";
import { colors } from "../../../options/colors";
import theme from "../../../theme/muiTheme";

const nameCheck = (option, value) =>
{
  return value === option.label
}
export const CustomSelect = ({
  label,
  name,
  onChange,
  placeholder,
  required,
  value,
  error,
  options,
  disabled,
}) =>
{
  return (
    <Container>
      {label && <Label text={label} required={required} />}
      <StyledSelect
        name={name}
        onChange={(e) => onChange(e)}
        displayEmpty
        value={value}
        IconComponent={SelectIcon}
        fullWidth
        selected={value}
        error={!!error}
        disabled={disabled}
      >
        <StyledMenuItem value="">{placeholder}</StyledMenuItem>
        {options &&
          options.map(({ value, label, color }) =>
          {
            return (
              <StyledMenuItem key={value} value={value}>
                {color && <StyledColorIcon color={color} />}
                {label}
              </StyledMenuItem>
            );
          })}
      </StyledSelect>
      {error && <FieldError error={error} />}
    </Container>
  );
};
export const CustomAutoSelect = ({
  label,
  name,
  onChange,
  placeholder,
  required,
  value,
  error,
  options,
  disabled,
}) =>
{
  return (
    <Container>
      <StyledAutocomplete
        theme={theme}
        disablePortal
        onChange={onChange}
        isOptionEqualToValue
        ={nameCheck}
        name={name}
        value={value}
        options={options}
        renderInput={(params) => (
          <TextField {...params}
            label={label}
            InputProps={{
              ...params.InputProps,
              sx: {
                color: value ? colors.white : colors.secondaryGrey
              }
            }}
          />
        )}
        renderOption={(props, option) => (
          <StyledAutoBox
            padding={0}
            borderColor={colors.secondaryGrey}
            color={option.hasStats ? colors.white : colors.secondaryGrey}
            component="li" value={option.value} {...props}>
            {option.color && <StyledColorIcon color={option.color} />}
            {option.label}
          </StyledAutoBox>
        )}
      />
      {error && <FieldError error={error} />}
    </Container>
  );
};
